import axios from "utils/axios";

export const getTranslations = () => {
  return axios.get("/hr/settings/translations");
};

export const getTranslationsDefault = () => {
  return axios.get("/hr/settings/translations/default");
};

export const resetTranslations = () => {
  return axios.post("/hr/settings/translations/reset");
};

export const updateTranslation = (data) => {
  return axios.put("/hr/settings/translations", data);
};
